import { React, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import '../components/Footer.css'

const Footer = () => {
  const [platform, setPlatform] = useState('Web');

  useEffect(() => {
    const detectPlatform = () => {
      const isPWA = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
      return isPWA ? 'PWA' : 'Web';
    };
    setPlatform(detectPlatform());
  }, []);
  return (
    <div>
      <div className="footer">
        <div className="contain">
          <div className="col">
            <h1>About Us</h1>
            <ul>
              <li><Link to="/about">Our Story</Link></li>
              <li><Link to="/feedback">Submit Feedback</Link></li>
            </ul>
          </div>
          <div className="col">
            <h1>Services</h1>
            <ul>
              <li><Link to="/daily-horoscope">Daily Horoscope</Link></li>
              <li><Link to="/mini-reports">Astrological Reports</Link></li>
              <li><Link to="/chat?mode=love">Marriage/Love Issues</Link></li>
              <li><Link to="/chat">Chat with Astrologer</Link></li>

            </ul>
          </div>
          <div className="col">
            <h1>Support</h1>
            <ul>
              <li><Link to="/support">Support</Link></li>
              <li><Link to="/tnc">Terms & Conditions</Link></li>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/returns">Return & Refund Policy</Link></li>
              <li><Link to="/delete-account">Delete Account</Link></li>
            </ul>
          </div>
          <div className="col social">
            <ul>
              <li>
                <a href="https://www.facebook.com">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6c/Facebook_Logo_2023.png" width="32" alt='.img' />
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/vedicrashi">
                  <img src="https://png.pngtree.com/png-clipart/20230401/original/pngtree-three-dimensional-instagram-icon-png-image_9015419.png" width="32" alt='.img' />
                </a>
              </li>
              <li>
                <a href="https://www.twitter.com">
                  <img src="https://static.vecteezy.com/system/resources/previews/027/395/710/non_2x/twitter-brand-new-logo-3-d-with-new-x-shaped-graphic-of-the-world-s-most-popular-social-media-free-png.png" width="32" alt='.img' />
                </a>
              </li>
            </ul>
          </div>
          {/* <ul>
              <li>
                {platform === 'PWA' ? (
                  <>
                    <i className="ri-smartphone-line"></i> Using PWA
                  </>
                ) : (
                  <>
                    <i className="ri-computer-line"></i> Using Website
                  </>
                )}
              </li>
          </ul> */}
          <div>
            <p className='footer-text'>Contact us at vedicrashiofficial@gmail.com.</p>
            <p className='footer-text'>© 2026 Vedic Rashi. All rights reserved.</p>
          </div>
          <div className="clearfix"></div>
          <hr />
          <h1 className='footer-name'>Vedic Rashi</h1>
        </div>
      </div>
    </div>
  )
}

export default Footer
